/**
 * @generated SignedSource<<63518270ee6c47b62570473af1ff23c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AskFellowPanelQuery$variables = {};
export type AskFellowPanelQuery$data = {
  readonly askCopilotConversations: ReadonlyArray<{
    readonly id: string;
    readonly title: string;
    readonly updatedAt: string;
  }>;
};
export type AskFellowPanelQuery = {
  response: AskFellowPanelQuery$data;
  variables: AskFellowPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AskCopilotConversation",
    "kind": "LinkedField",
    "name": "askCopilotConversations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowPanelQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AskFellowPanelQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5973874ddc822407998b68ea34429ddb",
    "id": null,
    "metadata": {},
    "name": "AskFellowPanelQuery",
    "operationKind": "query",
    "text": "query AskFellowPanelQuery {\n  askCopilotConversations {\n    id\n    updatedAt\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "2267c4bcd8827135d4569fe0f55b3652";

export default node;
